import { useState } from "react";
import title_symbol_black from "../../images/homepage/title_symbol_black.png";
import { HomefaqData } from "./HomefaqData";
import { IconContext } from "react-icons";
import { FiArrowDown, FiArrowUp } from "react-icons/fi";
import "../Faqpage/Faqpage.scss";
import AOS from "aos";
import "aos/dist/aos.css";
const Faqs = () => {
  const [clicked, setClicked] = useState(false);

  const toggle = (index) => {
    if (clicked === index) {
      //if clicked question is already active, then close it
      return setClicked(null);
    }

    setClicked(index);
  };
  return (
    <section className="faqsec">
      <div
        style={{
          fontSize: "3.438em",
          letterSpacing: "1.65px",
          lineHeight: "1.036em",
          marginBottom: "0.255em",
          fontFamily: "DVBTTBhimaENBold",
          textTransform: "uppercase",
        }}
        className="title text-center"
      >
        FAQ
      </div>
      <div className="text-center">
        <img
          style={{ width: "3.5em", height: "1.3em", marginBottom: "4em" }}
          src={title_symbol_black}
          alt="tower img"
        />
      </div>
      <IconContext.Provider value={{ color: "#1c1c1c", size: "25px" }}>
        <div className="accordionsec">
          <div className="acc_container">
            {HomefaqData.map((item, index) => {
              return (
                <>
                  <div
                    className="acc_wrap"
                    onClick={() => toggle(index)}
                    key={index}
                  >
                    <h1 className="title">{item.question}</h1>
                    <span className="acc_span">
                      {clicked === index ? <FiArrowUp /> : <FiArrowDown />}
                    </span>
                  </div>
                  {clicked === index ? (
                    <div className="acc_dropdown" style={{ paddingLeft: "0" }}>
                      <p
                        className="acc_p"
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      ></p>
                    </div>
                  ) : null}
                </>
              );
            })}
            <div className="line"></div>
          </div>
        </div>
      </IconContext.Provider>
    </section>
  );
};
export default Faqs;
